// Single source of truth for "is the Zendesk widget / support assistant
// launcher visible on this route". Historically the iOS handoff code had two
// call sites that each needed to agree on the same route set and drifted out
// of sync — this constant exists so that can't happen here: withAuthentication.js
// (widget show/hide) and Support.js (launcher visibility) both import it
// rather than each keeping their own copy of the regex.
export const SUPPORT_WIDGET_ROUTE_PATTERN =
  /^(\/|\/pricing|\/subscription|\/excess-shops|\/excess-employees|\/help|\/settings)$/i;

export const isSupportWidgetRoute = (pathname) => SUPPORT_WIDGET_ROUTE_PATTERN.test(pathname);
